import { render, staticRenderFns } from "./UpsellHomeSegments.vue?vue&type=template&id=1ad65311&"
import script from "./UpsellHomeSegments.vue?vue&type=script&lang=js&"
export * from "./UpsellHomeSegments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports